// extracted by mini-css-extract-plugin
export default {"Box":"filter-container-module__Box--dWujm"};